import { doc } from 'firebase/firestore';

import { AccountAiSettings } from '@superfunnel/types/account-ai-settings';

import { db } from '../Firebase';
import { emptyConverter } from '../utils';

export const getAccountAiSettingsDocRef = (accountId: string) =>
  doc(db, 'accounts', accountId, 'accountAiSettings', 'default').withConverter(
    emptyConverter<AccountAiSettings>(),
  );
